var scope_0 = require('/tmp/vultr-2-runner/work/kastle/kastle/packages/chateaudemorey/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b0e15a70d05a45337c306ab6341a6c6.js').default;

var scope_1 = require('/tmp/vultr-2-runner/work/kastle/kastle/packages/chateaudemorey/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a52c9b1a5d6a8de17115c367c30eb36c.js').default;

var scope_2 = require('/tmp/vultr-2-runner/work/kastle/kastle/packages/chateaudemorey/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2);